

const Header = ({children}) => {
  return (
    <div className="container bg-warning rounded-2">
        {children}
    </div>
  )
}

export default Header;